import styled, { StyledComponent } from "styled-components";
import React from "react";
const GetBold: React.CSSProperties = {
  fontWeight: "bold",
};
const MycartNav: React.CSSProperties = {
  boxShadow: "1px 2px 3px #c3c3c3",
};
const DeliveryInformation = styled.div`
.big-text{
  font-size:24px;
}
.medium-text{
  font-size:15px;
}
.small-text{
  font-size:14px;
}
  .btn-light {
    background-color: #eeeeee;
    border: 1px solid #d2d2d2;
    font-size: 14px;
  }
  .bg-light {
    background-color: #dbdbdb !important;
  }
  .btn-success {
    background-color: #1478DD;
  }
  .btn-sucess:focus{
    box-shadow:0 0 0 0.25rem #1478dd4a;
   }
  background-color: #fff;
  // border: 1px solid #d2d2d2;
  p {
    font-size: 14px;
    font-weight: 500;
  }

  @media screen and (min-width: 720px) {
    p {
      font-size: 16px;
    }
    .btn-light {
      font-size: 16px;
    }
  }
`;
const NavigationStyle = styled.div`
  #dropdown-variants-secondary {
    background-color: #eeeeee;
    border: 1px solid #dbdbdb;
    color: #000;
  }
  .bg-secondary {
    background-color: #dbdbdb !important;
  }
`;

const OrderDetails = styled.div`
  .orderDetails {
    div {
      padding: 0 10px;
      border-right: 1px solid #fff;
    }
  }
`;
const CartContainer = styled.div`
  border: 2px solid #d2d2d2;
  padding: 10px 0;
  margin: 0 20px;

  .float-right {
    position: relative;
    left: 100px;
    font-weight: 520;
    color: #1478DD;
  }

  .item-container {
    border: 2px solid #d2d2d2;
    width: 100%;
  }
  .cart-items {
    p {
      color: #000;
    }
    .text-success {
      color: #1478DD;
    }
  }
`;
export {
  GetBold,
  MycartNav,
  CartContainer,
  DeliveryInformation,
  NavigationStyle,
  OrderDetails,
};
